// src/app/store/reducers/index.ts
import { ActionReducerMap } from '@ngrx/store';
import { uiReducer } from './ui.reducer';
import { dashboardFeatureKey, dashboardFeatureReducer } from '../features/dashboard.feature';
import { authFeatureKey, authFeatureReducer } from '../features/auth.feature';
import { columnConfigReducer } from './column-config.reducer';
import { sourcesFeatureKey, sourcesFeatureReducer } from '../features/sources.feature';
import { ruleTypesFeatureKey, ruleTypesFeatureReducer } from '../features/rule-types.feature';
import { rulesFeatureKey, rulesFeatureReducer } from '../features/rules.feature';
import { AppState } from '../app.state';

// Re-export AppState for backward compatibility
export type { AppState } from '../app.state';

export const reducers: ActionReducerMap<AppState> = {
    ui: uiReducer,
    [dashboardFeatureKey]: dashboardFeatureReducer,
    [authFeatureKey]: authFeatureReducer,
    columnConfig: columnConfigReducer,
    [sourcesFeatureKey]: sourcesFeatureReducer,
    [ruleTypesFeatureKey]: ruleTypesFeatureReducer,
    [rulesFeatureKey]: rulesFeatureReducer
};
